import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const updateWebhook = async ({ id, input }, { client }) => {
    const data = await client.pim.request(graphql(`
      mutation UpdateWebhook($id: ID!, $input: UpdateWebhookInput!) {
        webhook {
          update(id: $id, input: $input) {
            id
          }
        }
      }
    `), { id, input });
    return data.webhook?.update.id;
};
